import Link from "next/link";
import type { NextPage } from "next";

const Home: NextPage = () => {
  return (
    <>
      <div className="flex flex-col justify-center items-center h-screen text-white ">
        {/* <Image className="w-6 h-6" width={32} height={32} src={user1} alt="" /> */}
        <span className="text-white gilroy-font text-[40px]">Fortux.io</span>
        <span className="gilroy-font-regular text-[20px] font-think">trading reality starting here.</span>
        <Link href="/login" className="gilroy-font-regular text-[20px] font-think">
          click me.
        </Link>
      </div>
    </>
  );
};

export default Home;
